/**
 * Se il modello si mostra all'operatore, e con quali cifre.
 *
 * **L'idoneita' la dichiara il servizio.** `acceptable` e `shortfall` arrivano
 * col dato: la pagina non confronta R1 con 0,90. La regola e' contrattuale — le
 * soglie dell'Allegato 5 — e riscriverla qui la duplicherebbe. Due copie di una
 * regola sono due regole, e la seconda si scopre il giorno in cui divergono:
 * cioe' quando la schermata dice «si puo' accendere» e il servizio rifiuta, e
 * chi guarda non sa a quale dei due credere.
 *
 * Anche le soglie arrivano dal servizio (`targets`): si mostrano per far capire
 * *quanto* manca, non per decidere.
 */
import { get, newKey, revoke, send } from '../api'

export interface ModelStanding {
  on_display: boolean
  r1: number | null
  r2: number | null
  error_rate: number | null
  declared: number
  predicted: number
  matched: number
  inspections: number
  /** Se le cifre consentono di mostrare il modello. Deciso dal servizio. */
  acceptable: boolean
  /** Che cosa manca alle soglie, in numeri e in italiano. */
  shortfall: string[]
  targets: Record<string, number>
}

export function readModelStanding(): Promise<ModelStanding> {
  return get<ModelStanding>('/model')
}

export function showModel(key = newKey()): Promise<ModelStanding> {
  return send<ModelStanding>('/model/display', {}, key)
}

/** Rimette il modello in ombra. Senza condizioni: spegnere non deve aspettare
 *  che qualcuno dimostri che il modello sta sbagliando. */
export function hideModel(key = newKey()): Promise<ModelStanding> {
  return revoke<ModelStanding>('/model/display', key)
}
